import {
	CircularProgress,
	Stack,
	TextField,
	Typography
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import BigButton from "../Common/BigButton";
import { SnackContext } from "../SnackContext";

export const RegisterForm = ({ switchComponent, passUserEmail }) => {

	const { showSnackMessage } = useContext(SnackContext);

	const [userEmail, setUserEmail] = useState("");
	const [registering, setRegistering] = useState(false);

	const [exists, setExists] = useState(false);

	const { t } = useTranslation();
	const { ApiCall } = useContext(ApiContext);

	const registerNewAccount = (e) => {
		console.log("Registering new account for: " + userEmail);
		setRegistering(true);
		e.preventDefault();

		ApiCall("POST", "user", {
			email: userEmail
		})
			.then(() => {
				switchComponent("validation");
				passUserEmail(userEmail);
				setRegistering(false);
			}).catch((e) => {
				setRegistering(false);

				if (e.response.data.error === "Email verified, reset password") {
					showSnackMessage("user_register", 401);
					setExists(true);
				}
				// replaces register button with quick switch to login recovery
				else setUserEmail("");
			});
	};

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	useEffect(() => {
		setExists(false);
	}, [userEmail]); // hide error message and revert button functionality if email is altered

	return (
		<form onSubmit={registerNewAccount} style={{ width: "100%" }}>
			<Stack spacing={3}>
				<Typography sx={{ color: ColorScheme.lightGrey, fontSize: "14px" }}>
					{t("login.email_label")}*
				</Typography>

				<TextField
					placeholder={t("login.insert_email")}
					sx={{
						backgroundColor:ColorScheme.lightGrey,
						borderRadius: "5px"
					}}
					id="user_email"
					variant="outlined"
					margin="dense"
					fullWidth={true}
					size="small"
					error={exists} // error highlights textfield if user tries to register with email which is already used
					onChange={(e) => setUserEmail(e.target.value)}
				/>
				<Stack
					style={{ justifyContent: "center", alignItems: "center" }}
				>
					{!registering ? (
						<Stack style={{ width: "100%" }} spacing={3}>
							{exists ? (
								<BigButton
									text={t("buttons.forgot_account_details")}
									backgroundColor={ColorScheme.primary}
									borderColor={ColorScheme.primary}
									textColor={ColorScheme.textPrimary}
									action={() => switchComponent("forgot")}
								/>
							) : (
								<BigButton 
									text={t("buttons.register_account")}
									backgroundColor={ColorScheme.primary}
									textColor={ColorScheme.textPrimary}
									borderColor={ColorScheme.primary}
									action={registerNewAccount}
									disabled={!validateEmail(userEmail)}
									activity={registering}
								/>
							)}
							<BigButton
								text={t("buttons.return_to_login")}
								backgroundColor={ColorScheme.transparent}
								textColor={ColorScheme.textPrimary}
								borderColor={ColorScheme.secondary}
								action={() => switchComponent("login")}
							/>
						</Stack>
					) : (
						<CircularProgress color="info" />
					)}
				</Stack>
			</Stack>
		</form>
	);
};
